import { APP_CONFIG } from '../../config';
import { get } from '../request';
import { Product, ProductApiResponse } from '../../@types/product';
import { productsToApp } from './converter/products';

export const getProducts = async (): Promise<Product[]> => {
  const productsRes: ProductApiResponse = await get(`${APP_CONFIG.entitlementApiUrl}/v2/active-products/my`);
  return productsToApp(productsRes);
};
